import React, { Component } from 'react'
import Slider from './slider'
import { SILVER } from '../utils/colors'


class Spotlight extends Component {

    render() {
        return (
            <div className='level columns'>
                <div className='column is-half'>
                    <h2 className='title is-4' style={{color: SILVER}}>{this.props.title}</h2>
                    <h3 className='subtitle is-6' style={{color: SILVER}}>{this.props.description}</h3>
                    {
                        this.props.link ?
                            <a className='button' href={this.props.link.uri} target='_blank'>{this.props.link.name}</a>
                            :
                            ''
                    }
                </div>
                <div className='column is-half'>
                    <Slider images={this.props.images} wide={this.props.wide} video={this.props.video}/>
                </div>
            </div>
        )
    }

}


export default Spotlight



// WEBPACK FOOTER //
// ./src/components/spotlight.js